import { FC } from 'react';
// component
import DuplicateFormulaComponent from 'components/main/Formulas/Dosage/Duplicate';

const DuplicateFormula: FC = () => <DuplicateFormulaComponent />;

export default DuplicateFormula;
